import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  LeeOAuthentication,
  LeeOAuthenticationResponse,
  LeeOAuthenticationUpsertedResponse,
  UpsertLeeOAuthenticationRequest,
} from '../models/third-parties.model';

@Injectable({
  providedIn: 'root',
})
export class LeeOIntegrationService {
  private secureBaseUrl = `${this.env.API_BASE_URL}/service/lee-o-integration/secure`;
  private authenticationPath = 'authentication';

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: { API_BASE_URL: string },
  ) {}

  getAuthentication(): Observable<LeeOAuthentication | HttpErrorResponse> {
    return this.http
      .get<LeeOAuthentication>(`${this.secureBaseUrl}/${this.authenticationPath}`)
      .pipe(
        map((response: LeeOAuthenticationResponse) => response),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<LeeOAuthentication>{});
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  upsertAuthentication(
    request: UpsertLeeOAuthenticationRequest,
  ): Observable<LeeOAuthenticationUpsertedResponse | HttpErrorResponse> {
    return this.http.post<LeeOAuthenticationUpsertedResponse>(
      `${this.secureBaseUrl}/${this.authenticationPath}`,
      request,
    );
  }

  deleteAuthentication(leeOAuthenticationId: number) {
    return this.http.delete(
      `${this.secureBaseUrl}/${this.authenticationPath}/${leeOAuthenticationId}`,
    );
  }
}
